import { Button } from "antd";
import PropTypes from "prop-types";

const SecondaryButton = ({ children, ...props }) => {
  const className = `bg-white text-custom_darkgray border-1 border-custom_gray hover:text-custom_primary hover:border-custom_primary ${
    props.className ? props.className : ""
  }`;
  return (
    <Button {...props} className={className}>
      {children}
    </Button>
  );
};

SecondaryButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
export default SecondaryButton;
